import classnames from 'classnames'
import Icon from 'shared/components/Icon'
import styles from './styles.module.scss'

export const LocationCard = ({ locationName }) => (
    <div className={classnames(styles.location, 'd-flex')}>
        <Icon type="pin" size="sm" />
        <span>{locationName}</span>
    </div>
)
